import React from 'react';

export function Cards(props: { image: string; subtext: string }) {
  const { image, subtext } = props;
  return (
    <div className="w-38  h-14 bg-white rounded-md m-1 flex bg-opacity-10 bg-clip-padding">
      <div className="h-auto w-20 flex items-center justify-center">
        <img src={image} alt="metal" className="w-8 h-8" />
      </div>
      <div className="text-xs w-full  text-white font-medium flex items-center pr-1  ">
        <p className="w-full px-1">{subtext}</p>
      </div>
    </div>
  );
}
